export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'right',
    width: 80,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'categoryName',
    align: 'left',
    minWidth: 150,
    title: that.$l('table_label_categoryName') || '产品分类',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'materialInfo',
    align: 'left',
    minWidth: 180,
    title: that.$l('table_label_materialInfo') || '材料信息（中文）填写要求',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'materialInfoEn',
    align: 'left',
    minWidth: 200,
    title: that.$l('table_label_materialInfoEn') || '材料信息（英文）填写要求',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    field: 'modifyByName',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
